import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import InputText from 'modules/_shared/components/InputText';
import MandatoryField from 'modules/_shared/components/MandatoryField';

import { numberFormat } from 'constants/formats';
import actionTypes from 'constants/actionTypes';

import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';
import { useAddHoldingClassModal } from '../context/AddHoldingClassModalContext';
import HoldingClassRights from './HoldingClassRights';

const AddHoldingClassModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddHoldingClassModal();

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  return (
    <Modal.Body>
      <div className="nk-modal">
        <div className="form-group">
          <InputText
            id="name"
            label={t('Name')}
            value={data.name}
            onChange={actions.onChangeName}
            required
            lgSize
            disabled={isReadOnlyView}
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="nominal-value">
            {t('NominalValue')} <MandatoryField />
          </label>
          <div className="form-control-wrap">
            <NumberFormat
              id="nominal-value"
              className="form-control form-control-lg"
              value={data.nominalValue}
              onChange={actions.handleChangeNominalValue}
              thousandSeparator={numberFormat.thousandSeparator}
              decimalSeparator={numberFormat.decimalSeparator}
              allowNegative={false}
              decimalScale={10}
              disabled={isReadOnlyView}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="nunmeration-select-input">
            {t('StartNumberingFrom')} <MandatoryField />
          </label>
          <div className="form-control-wrap">
            <CustomAsyncSelect
              id="numeration-select-input"
              value={data.selectedNumerationClassOption}
              onChange={actions.handleChangeNumerationClassOption}
              onFetchData={actions.handleFetchHoldingClassByTerm}
              placeholder={t('SearchClass')}
              minimumInputLength={1}
              noDataLabelKey="NoClassesHaveBeenFound"
              loadingLabelKey="LoadingClasses"
              errorLabelKey="ErrorLoadingClasses"
              defaultOptions={data.numerationClassOptions}
              isClearable={false}
              isDisabled={
                data.modalActionType === actionTypes.EDIT || isReadOnlyView
              }
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="votes">
            {t('NumberOfVotesForEachParti')}
          </label>
          <div className="form-control-wrap">
            <NumberFormat
              id="votes"
              className="form-control form-control-lg"
              value={data.votes}
              onChange={actions.handleChangeVotes}
              thousandSeparator={numberFormat.thousandSeparator}
              decimalSeparator={numberFormat.decimalSeparator}
              allowNegative={false}
              decimalScale={0}
              disabled={isReadOnlyView}
            />
          </div>
        </div>

        <HoldingClassRights />

        <div className="form-group">
          <label className="form-label" htmlFor="conversion-rate">
            {t('ConversionRate')}
          </label>
          <span className="sub-text mb-3">
            {t('WhatIsTheConversionRateWh')}
          </span>
          <div className="form-control-wrap">
            <NumberFormat
              id="conversion-rate"
              className="form-control form-control-lg"
              value={data.conversionRate}
              onChange={actions.handleChangeConversionRate}
              thousandSeparator={numberFormat.thousandSeparator}
              decimalSeparator={numberFormat.decimalSeparator}
              allowNegative={false}
              decimalScale={0}
              disabled={isReadOnlyView}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="lockup-period">
            {t('Lock-UpPeriod')}
          </label>
          <span className="sub-text mb-3">
            {t('RightOfTransmissionOfTheP')}
          </span>
          <div className="form-control-wrap">
            <input
              id="lockup-period"
              type="date"
              className="form-control form-control-lg"
              value={data.lockupPeriod || ''}
              onChange={actions.handleChangeLockupPeriod}
              disabled={isReadOnlyView}
            />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
};

export default AddHoldingClassModalBody;
